import React from 'react'

const LoadingSpinner = () => {
    return (
        <div class="w-full h-screen flex items-center justify-center space-x-2 animate-bounce">
            <div class="w-9 h-9 bg-blue-400 rounded-full"></div>
        </div>
    );
};

export default LoadingSpinner;